module.exports = __webpack_public_path__ + "static/img/img_title_02.6aeb2e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_02.png
// module id = 190
// module chunks = 1